module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"page.title":"เพิ่ม Drone Model รุ่นใหม่","page.description":"เพิ่ม Drone Model รุ่นใหม่ในระบบ","create_model.success":"ทำการเพิ่ม Drone รุ่นใหม่ {name} ในระบบเรียบร้อย","create_model.submit.label":"เพิ่ม Drone รุ่นใหม่","create_model.confirm.title":"ยืนยันการสร้าง Drone Model ใหม่","create_model.confirm.message":"คุณต้องการสร้าง Drone Model รุ่นใหม่นี้ ?"}}')
  delete Component.options._Ctor
}
